export default  {	
	data () {
		return { 
			total: 0,
			active: 0,
			updates: 0,
			estado: 1,
			ultimoMes: 0,
			ultimoAno: 0,

		}
	},
	destroyed(){
		this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
		this.searchSw.value=''	
	},
	updated()
	{
		if(this.errornotification)
		{
			this.changeGlobal({ state: 'saveConfig/notification/error', boolean: true})
			this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
		}
	},
	async created () { 
		await this.onInit()
	},
	methods:{
		async onInit()
		{	
			this.searchSw.value=''	
			const await00 = this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
			const await0 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})	
			const await1 = this.resetDataForm()
			await Promise.all([await00,await0,await1])
			const await2 =  this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
			const await3 =  this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })
			await Promise.all([await3,await2])
		}
	}
}
